import React from 'react';

const authBackground = `${process.env.PUBLIC_URL}/images/slides/stats-elite-data-consulting.png`;

const AuthSliderPanel = ({ eyebrow, title, text }) => (
  <aside className="auth-slider-panel" aria-label="Stats Elite highlights">
    <div className="auth-slider-media">
      <img src={authBackground} alt="" aria-hidden="true" className="auth-slide auth-slide-static" />
    </div>
    <div className="auth-slider-overlay"></div>
    <div className="auth-slider-content">
      <span className="auth-slider-eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      <p>{text}</p>
    </div>
  </aside>
);

export default AuthSliderPanel;
